import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';

function MaterialSearch({ value, setValue, defaultValue, showHelper = true, label ="" }) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        if (search && search.length > 0 && open) {
            axios.get('/GetMaterials/' + search.toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    const response = res.data;
                    if (response.length > 0) {
                        setOptions(response);
                    } else {
                        setOptions([]);
                    }
                }).catch(err => {
                    setOptions([]);
                });
        }
    }, [search, open]);

    return (
        <Autocomplete
            open={open}
            value={value}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionLabel={(option) => { return option.MaterialCode ? (option.MaterialCode + ' - ' + option.MaterialDesc) : '-' }}
            options={options}
            filterOptions={(options, state) => options}
            loading={loading}
            onChange={(event, newValue) => {
                if (newValue && newValue.MaterialCode) {
                    setValue(newValue);
                } else {
                    setValue(defaultValue);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    label={label}
                    onChange={e => { setSearch(e.target.value) }}
                    variant="outlined"
                    placeholder="Malzeme Seçiniz!..."
                    helperText={showHelper && value ? value.MaterialDesc : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export default MaterialSearch;
